/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import parse from 'html-react-parser';

import { ProgressiveDisclosure } from '@plans-templates/progressive-disclosure';
import { ReviewDetailsModal } from '@plans-templates/review-details';
import { PlanExtras } from '@plans-templates/plan-extras';
import { PlanDiscountModal } from '@plans-templates/plan-discount';
import { TextLink } from '@vds/buttons';
import { convertStringToElements } from '@vds/html-parsers';
import { ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Body } from '@vds/typography';
import Button from '../../common/Button/index';
import * as actionTypes from '../../../pages/ProgressivePlans/@Redux/actionTypes';
import {
  ProgressivePlansProps,
  getReviewList,
  scrollToBroadBandFacts,
  broadBandInfoClick,
  getWayfinder,
  getDiscountLabel,
  addPromoBannerLinkClickListner,
  showPopularPlanLink,
} from '../../../pages/ProgressivePlans/progressivePlan';
import ComparePlanComponent from '../../Movers/moversPlansOverview/Overlays/comparePlanModel';

import {
  isLoggedIn,
  isVFEligibile,
  parseHTML,
  isMobile,
  setSession,
  isSequentialFlow,
  isJointTransactionFlow,
  getColorTheme,
  getSession,
  getPageName,
  getIntendType,
  showLocalOffer,
  getCookie,
  prefetchAddonsAsync,
  removeSessionItem,
  isPlansVisitLq,
} from '../../common/Helpers';
import PerkDetailOverlay from '../../../pages/ProgressivePlans/perkDetailsModal';
import TermsAndConditionsOverlay from '../../../pages/ProgressivePlans/common/termsAndConditions/index';
import '../../../assets/css/willow.scss';
import Notification from '../../common/Notification/redesign/index';
import IPILink from '../ImportantPlanInfo/index';
import PerkDisclosureModal from '../../../pages/ProgressivePlans/perkDisclosureModal';
import { FWAContainer } from '../../common/FWAContainer';
import { Row, Col } from '../../common/Grid';
import { getTooltipContents, fetchMHDiscounts } from './common';
import PerkDuplicateModal from '../../../pages/ProgressivePlans/duplicateMessage';
import { eventDispatcher, setPageViewOverrides, modalOpenPageView } from '../../common/Tagging/index';
import {
  checkIsMoversPlansPage,
  discountArgs,
  storePlanDataAfterDiscounts,
  getComparePlansPrice,
  getPriceGuarantee,
  isLegacyPlanFunc,
} from '../../common/plansUtils';
import { checkPlanReferenceData } from '../../../utils/plansReference';
import { POPULAR_CUSTOMIZED, PROGRESSIVE, UPDATE_PLAN_JOURNEY } from '../../../pages/Common/SessionValues/Constants';
import PerkConflictModal from '../../../pages/ProgressivePlans/conflictPerksModal';
import { loopQualVzTaglqs } from '../../common/Helpers/taggingHelper';
import { commonErrors } from '../../common/Helpers/constants';
import * as Constants from '../../../pages/CBandPlans/Constants';
import { VDSModal as Modal } from '../../common/Modal/VDSModal';
import { Margin } from '../../common/styles';
import * as moversactionTypes from '../../../pages/Movers/@Redux/actionTypes';

const BannerDiv = styled.div`
  background: #5a5a5a;
  padding: 10px;
  max-height: 100%;
`;
const ACPModalBody = styled.div`
  .description {
    margin-bottom: 24px;
  }
  .terms {
    font-size: 11px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.5px;
  }
`;
const ProgressivePlans = (props) => {
  const userType = isLoggedIn() ? 'aal' : 'nse';
  const checkMoversFlag = checkIsMoversPlansPage() !== true;
  const [showComparePlanModel, updateComparePlanModel] = useState(false);
  const [isLegacyPlan, updateLegacyPlanDetails] = useState(false);
  const [currentSelectedPlanDetails, updateSelectedPlanDetails] = useState(null);
  const [onclickOnLink, updateLinkClickStatus] = useState(false);

  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showLQAddress, setShowLQAddress] = useState(true);
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [showVfModal, setVfShowModal] = useState(false);
  const [showExtrasModal, setExtras] = useState(false);
  const [showModalData, setShowModalData] = useState(null);
  const [showDiscountsModal, setShowDiscountsModal] = useState(null);
  const [showDisneyPerkDetailModel, setShowDisneyPerkDetailModel] = useState(false);
  const location = useLocation();
  const [accordianEventFired, setAccordianEventFired] = useState(false);
  const storeDetails = useStore().getState();
  const resetReadDLAPIStatus = () => dispatch({ type: 'TAGGING_API_LOADED', response: false, pageName: getPageName() });
  const readDLSuccess = useSelector((reduxStore) => reduxStore.SessionValues?.tagging?.[getPageName()]?.success);
  const showPlansSection = useSelector((reduxStore) => reduxStore?.progressivePlans?.planAccordionState?.show);
  const promoBannerText = useSelector((reduxStore) => reduxStore?.cBandPlans?.plansDetails?.willowOverview?.[0]?.promoBannerText);
  const moversAccountMDN = useSelector((reduxStore) => reduxStore?.moversReducer?.mtn);
  const cbandFedDetails = useSelector((reduxStore) => reduxStore?.moversReducer?.cbandJson);
  const comparePlanDetails = useSelector((reduxStore) => reduxStore?.moversReducer?.comparePlan);
  const isMoversFlow = checkIsMoversPlansPage() === true;

  const plansAccordianContainerId = 'plans-accordian-container';
  const isFWALQS = getSession('FWA_LQSPO');
  const isResponsiveLQ = isPlansVisitLq();
  const { perkStaticContent = {} } = storeDetails?.plansReferenceData?.output || {};
  const {
    disneyPerkDetailsModelHeader = '',
    disneyPerkDetailsModelBody = [],
    specialOfferTitle = '',
    disneyPromoBannerTitle = '',
  } = perkStaticContent;
  window.vzlqwPlan = {};
  const AddressShow = () => {
    setShowLQAddress(true);
  };
  window.vzlqwPlan.lqAddressShow = AddressShow;
  const progressivePlan = () => {
    dispatch({ type: actionTypes.PROGRESSIVE_PLANS_API, data: { value: true, processingMDN: moversAccountMDN } });
  };
  const cBandPlanDetails = (data) => {
    dispatch({ type: actionTypes.CBAND_FED, data });
  };
  const fccLabelContentActions = (data) => {
    dispatch({ type: actionTypes.FCC_LABEL, data });
  };
  const perksDetails = () => {
    dispatch({ type: actionTypes.PERKS_MODAL_DETAILS_API, value: true });
  };
  const bannerPlansAPI = (data) => {
    dispatch({ type: 'BANNER_PROMOTION_FLOW', data });
  };
  const subscriptionDetails = () => {
    if (isLoggedIn()) {
      dispatch({ type: actionTypes.NETFLIX_PLUSPLAY_OVERLAY, value: true });
    }
  };
  useEffect(() => {
    addPromoBannerLinkClickListner(showPromoModal, setShowPromoModal);
  }, [promoBannerText]);
  useEffect(() => {
    resetReadDLAPIStatus();
  }, [dispatch, location]);

  useEffect(() => {
    if (storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.currentPlanInfo) {
      setSession('oldPlanName', storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.currentPlanInfo?.displayName); // p45 tagging
      const data = isLegacyPlanFunc(
        storeDetails?.plansReferenceData?.output?.willowFeatures ? Object.keys(storeDetails?.plansReferenceData?.output?.willowFeatures) : [],
        String(storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.currentPlanInfo?.planId),
      );
      updateLegacyPlanDetails(data);
    }
  }, [storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data, storeDetails?.plansReferenceData]);

  const lineLevelInfo = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.lineLevelPlans
    ? storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.lineLevelPlans
    : {};
  const plansData = (lineLevelInfo?.lines?.length > 0 && lineLevelInfo?.lines[0].products[0]) || [];
  const { staticContent } = storeDetails?.plansReferenceData?.output || {};
  const { contextInfo } = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data || {};
  const { getfwaplansLoaded } = storeDetails?.progressivePlans;
  const plansAndPerks = [];
  if (plansData?.plans?.length > 0) {
    plansAndPerks.push(...plansData?.plans);
  }
  if (lineLevelInfo?.lines?.length > 0 && lineLevelInfo?.lines[0].availablePerks) {
    plansAndPerks.push(...lineLevelInfo.lines[0].availablePerks);
  }
  const currentPlanObject = {
    planId: storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.currentPlanInfo?.planId,
    obj: storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.currentPlanInfo,
  };
  const selectedPlan = storeDetails?.progressivePlans?.selectedPlanInfo?.selectedPlan || {};
  const { perkPdpOverlay, termsAndConditionsOverlay } = storeDetails?.progressivePlans;
  const autoPayOn = storeDetails?.progressivePlans?.autoPayOn;
  const isEmp = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.employee;
  const willowFeatures = storeDetails?.plansReferenceData?.output?.willowFeatures || {};
  const lineActivity = `${getIntendType()}`;
  setSession('autoPayPreview', autoPayOn ? 'Y' : 'N');
  const modalChanged = (state) => {
    setShowModal(state);
    if (state) {
      const obj = { name: `Review details | ${showModalData?.title?.children} plan modal`, data: { page: { detail: 'plans accordion' } } };
      eventDispatcher('openView', obj);
    }
  };
  const vfModalChanged = (state) => {
    setVfShowModal(state);
  };

  const nbxFeedBackCall = () => {
    dispatch({
      type: actionTypes.FEEDBACK_API,
      feedBackTile: plansAndPerks,
      mtn: 'newLine1',
      dispositionOptionId: 82,
      lineActivityType: lineActivity,
      selectedLLP: '',
      feedbackContextInfo: staticContent?.feedbackContextInfo,
      nbxSessionId: contextInfo?.sessionId,
      tacticLocation: '',
    });
  };

  useEffect(() => {
    const flowType = getSession('FlowType') || '';
    const isLoggedInVar = getCookie('loggedIn') || getCookie('userinfo');
    const isLQACalled = getSession('fwa_lqaCalled') === 'Y';

    if (isFWALQS && flowType && !isLoggedInVar && isLQACalled) {
      loopQualVzTaglqs();
      removeSessionItem('fwa_lqaCalled');
    }

    if (isJointTransactionFlow()) {
      const { search } = window.location;
      if (search.includes('line=')) {
        const params = new URLSearchParams(search);
        const line = params.get('line');
        dispatch({ type: 'JOINT_TRANSACTION_LINE', value: line });
      }
    }
    dispatch({ type: actionTypes.UPDATE_ERROR_NOTIFICATION, payload: false });
    dispatch({ type: Constants.ERR_OCCURED, response: false });
    dispatch({ type: Constants.CEF_PLANS_ERROR, response: false, errorMessage: null });
    dispatch({ type: Constants.INVALID_CASE_ERROR, response: false });
    resetReadDLAPIStatus();
    if (!isLoggedIn()) {
      props.invokeTaggingAPI();
    }
    checkPlanReferenceData();
    progressivePlan();
    cBandPlanDetails();
    fccLabelContentActions();
    if (checkMoversFlag) {
      perksDetails();
      subscriptionDetails();
      if (showLocalOffer()) {
        const LQResponseData = JSON.parse(getSession('LQResponse'));
        bannerPlansAPI(LQResponseData?.output);
      }
    }

    return () => resetReadDLAPIStatus();
  }, []);

  useEffect(() => {
    // To open plans accordion when there is no plan selection and plansAccordionState is false
    if (!selectedPlan?.planId && !storeDetails?.progressivePlans?.planAccordionState?.show) {
      window.scrollTo(0, 0);
      dispatch({ type: 'UPDATE_PLANS_ACCORD_STATUS', response: true });
    }
  }, [selectedPlan]);

  useEffect(() => {
    if (getfwaplansLoaded && staticContent?.FeedbackApiFlag && checkMoversFlag) {
      nbxFeedBackCall();
    }
    if (getfwaplansLoaded && prefetchAddonsAsync()) {
      const callAddonsApi = setInterval(async () => {
        if (callAddonsApi) {
          clearInterval(callAddonsApi);
        }
        await props.getAddons(true);
      }, 1000);
    }
    if (getfwaplansLoaded && isLoggedIn()) {
      initatePageViewOverides();
      props.invokeTaggingAPI();
    }
  }, [getfwaplansLoaded]);

  useEffect(() => {
    const isPerksEdit = getSession('isPerksEdit') === 'Y';
    if (readDLSuccess && !accordianEventFired && !isPerksEdit && showPlansSection) {
      const obj = { name: 'plans accordion ', selector: `#${plansAccordianContainerId}` };
      eventDispatcher('openView_v2', obj);
      setAccordianEventFired(true);
    }
  }, [dispatch, readDLSuccess]);

  const initatePageViewOverides = () => {
    if (!isLoggedIn() || showPopularPlanLink(storeDetails)) {
      return;
    }
    const popularPlanSuppresed = {
      data: {
        page: {
          detail: 'ppsup_progressiveplans',
        },
      },
    };
    setPageViewOverrides(getPageName(), popularPlanSuppresed);
  };

  const fetchMHDiscountsCommon = (planId) => {
    const item = plansAndPerks && plansAndPerks?.length > 0 && plansAndPerks.filter((item) => item.planId === planId);
    fetchMHDiscounts(item?.[0], storeDetails);
  };

  const planSelection = (e, plan) => {
    if (checkIsMoversPlansPage()) {
      const { history } = props;
      dispatch({
        type: moversactionTypes.MOVERS_UPDATE_CUSTOMER_PLAN,
        payload: {
          moveInDate: getSession('moveInDate'),
          newtworkBandWidth: getSession('networkBandwidthType'),
          currentPlanId: currentPlanObject?.planId,
          newPlanId: plan?.planId,
        },
        history,
      });
      const selectedPlanData = plan?.planId;
      storePlanDataAfterDiscounts(props, selectedPlanData, plan, fetchMHDiscountsCommon);
      // try block is not used so not added here
    } else {
      const plansAccordianContainer = document?.getElementById(plansAccordianContainerId);
      if (plansAccordianContainer) {
        plansAccordianContainer.scrollIntoView({ behavior: 'smooth' });
      }
      const { SessionValues: { planSelectionJourney } = {} } = storeDetails;
      if (planSelectionJourney !== POPULAR_CUSTOMIZED) {
        dispatch({ type: UPDATE_PLAN_JOURNEY, value: PROGRESSIVE });
      }
      dispatch({ type: actionTypes.UPDATE_PLANS_ACCORD_STATUS, response: false });
      dispatch({
        type: 'UPDATE_SELECT_DATA_PLAN',
        value: {
          selectedPlan: {
            planId: plan?.planId,
            discountedPrice: plan?.price?.discountedPrice,
            regularPrice: plan?.price?.regularPrice,
            regPriceWOAutoPay: plan?.price?.regPriceWOAutoPay,
            discPriceWOAutoPay: plan?.price?.discPriceWOAutoPay,
            displayName: plan?.displayName,
            from: 'progressivePlanPage',
          },
        },
      });

      dispatch({ type: actionTypes.UPDATE_ERROR_NOTIFICATION, payload: false });
    }
  };

  const toggleOfferModalVal = (val) => {
    if (!val) {
      setShowPromoModal(false);
    }
  };
  const getProductsRefData = (data) => {
    const updatedData = {};
    if (data && data.length) {
      data.forEach((element) => {
        updatedData[element.productId] = element;
      });
    }
    return updatedData;
  };
  const getProductsRefDataId = (data) => {
    const updatedData = {};
    if (data && data.length) {
      data.forEach((element) => {
        updatedData[element.planId] = element;
      });
    }
    return updatedData;
  };
  const closeExtrasModal = () => {
    setExtras(false);
  };

  const toggleOnComplarePlanModel = () => {
    modalOpenPageView('compare plan modal');
    if (showComparePlanModel === false) {
      updateLinkClickStatus(true);
      dispatch({ type: moversactionTypes.COMPARE_PLAN_API });
      if (isLegacyPlan === true) {
        dispatch({ type: moversactionTypes.GET_CBAND_FED_JSON });
      }
    }
  };

  useEffect(() => {
    if (comparePlanDetails?.errorInfo?.status === false && comparePlanDetails?.planDetails !== null && onclickOnLink === true) {
      updateComparePlanModel(true);
    }
  }, [comparePlanDetails, onclickOnLink]);

  const toggleOffComplarePlanModel = (value) => {
    updateComparePlanModel(value);
    updateLinkClickStatus(value);
  };
  const getList = (Features) => {
    const pprd = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.planProductReferenceDataList
      ? getProductsRefData(storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.planProductReferenceDataList)
      : [];
    const list = [];
    const isTgwFlow = getSession('isTGW');
    Features.forEach((productId) => {
      const productInfo = pprd?.[productId] || {};
      if (
        productInfo &&
        (isTgwFlow ? productInfo.description !== 'Free Professional Setup' : productInfo.description !== 'Verizon Cloud Unlimited')
      ) {
        list.push({
          title: { children: productInfo.description },
          icon: { name: productInfo.icon, ariaHidden: 'true', tabindex: '-1' },
          spacing: 'compact',
          subtitle: { children: productInfo?.groupName?.toUpperCase() === 'SPEED' ? parseHTML(productInfo.marketingDesc) : '' },
        });
      }
    });
    return list;
  };
  const getTiles = (plans, planReferenceDataList, allPlanDetails) => {
    const tiles = [];
    plans.forEach((item) => {
      if (String(item?.planId) === String(currentPlanObject?.planId)) {
        return;
      }
      const matchingPlan = planReferenceDataList.filter((plan) => plan?.planId?.toString() === item.planId);
      const planProducts = matchingPlan[0]?.planProducts;
      const reviewDetailsArgs = {
        title: {
          children: item?.displayName,
          primitive: 'h2',
        },
        theme: getColorTheme(),
        list: planProducts && getReviewList(planProducts, storeDetails),
        'data-track': `{"type": "link","name": "close","data":{"page":{"detail":"Review details | ${matchingPlan[0]?.displayName} plan modal" }}}`,
        buttonData: {
          primary: {
            children: 'Close',
            'data-track': `{"type": "link","name": "close","data":{"page":{"detail":"Review details | ${matchingPlan[0]?.displayName} plan modal" }}}`,
            onClick: () => {
              setShowModal(false);
              closeExtrasModal();
            },
          },
        },
        ariaLabel: `${item?.displayName} overlay`,
      };

      const { planId } = item;
      const promo_DataVal = allPlanDetails?.willowPlanExtras?.[planId] || {};
      const promo_Choice_Title = promo_DataVal?.[`planChoiceExtrasTtl_${userType}`] || [];
      const extras_Title = promo_DataVal?.[`planExtrasTitle_${userType}`] || [];
      const promoDesc_Common = promo_DataVal?.[`planExtrasDesc_${userType}`] || [];
      const promo_Desc = promo_DataVal?.[`planChoiceExtrasDesc_${userType}`] || [];
      const choice_Olay_Ttl = promo_DataVal?.[`choiceOlayTtl_${userType}`] || [];
      const choice_OlayImg = promo_DataVal?.[`choiceOlayImage_${userType}`] || [];
      const choice_Olay_Subhead = promo_DataVal?.[`choiceOlaySubhead_${userType}`] || [];
      const choice_Olay_SubheadDesc = promo_DataVal?.[`choiceOlaySubheadDesc_${userType}`] || [];
      const choice_OlayDesc = promo_DataVal?.[`choiceOlayDesc_${userType}`] || [];
      const choice_Olay_Steps = promo_DataVal?.[`choiceOlaySteps_${userType}`] || [];
      const choice_OlayFtr = promo_DataVal?.[`choiceOlayFtr_${userType}`] || [];
      const choice_OlayFeat = promo_DataVal?.[`choiceOlayFeat_${userType}`] || [];
      const choice_Olay_StepsHead = promo_DataVal?.[`choiceOlayStepsHead_${userType}`] || [];
      const choice_Olay_FeatHeader = promo_DataVal?.[`choiceOlayFeatHeader_${userType}`] || [];
      const plan_ExtrasLink = promo_DataVal?.[`planExtrasLink_${userType}`] || [];
      const featureData = willowFeatures?.[planId] || {};
      const featureDataWillow = allPlanDetails?.willowPlanExtras?.[planId] || {};
      const extra_Callout = promo_DataVal?.[`extrasCallout_${userType}`];
      const images_Array = promo_DataVal?.[`extrasIconCommon_${userType}`];
      const primary_Image = images_Array?.length > 0 && images_Array[0];
      const promosLength = promo_Choice_Title.length > 0 || extras_Title.length > 0;
      const bestValueBannerText = checkMoversFlag
        ? featureDataWillow?.extrasCallout
          ? featureDataWillow?.extrasCallout
          : featureDataWillow?.[`extrasCallout_${userType}`]
        : item?.displayName?.toLowerCase()?.includes('plus')
          ? props?.bestValueTxt
          : '';
      const choice_Olay_TtlArray = choice_Olay_Ttl?.map(
        (item, index) =>
          choice_Olay_Ttl[index] !== '-NA-' && {
            primitive: 'h2',
            children: choice_Olay_Ttl[index],
          },
      );
      const choice_Olay_SubheadArray = [...choice_Olay_Subhead]?.map((item, index) => ({
        title: {
          children: choice_Olay_Subhead[index] !== '-NA-' && choice_Olay_Subhead[index],
          primitive: 'h3',
        },
        body: {
          children: choice_Olay_SubheadDesc[index] !== '-NA-' && choice_Olay_SubheadDesc[index],
        },
      }));
      const tempChoiceOlayFeat = choice_OlayFeat?.map((item) => Object.values(item));
      const choice_Olay_FeatArray = [...tempChoiceOlayFeat]?.map((item, index) => {
        if (item !== '-NA-') {
          const parsed_Items = [];
          for (let i = 0; i < item?.length; i++) {
            parsed_Items.push(parseHTML((item[i] !== '-NA-' && item[i]) || ''));
          }
          return {
            title: {
              children: item.length > 0 && choice_Olay_FeatHeader[index],
              primitive: 'h3',
            },
            list: parsed_Items?.map((parsedItem) => ({ children: parsedItem })),
          };
        }
        return null;
      });

      const tempchoiceOlaySteps = choice_Olay_Steps?.map((item) => Object.values(item));

      const choice_Olay_StepsArray = [...tempchoiceOlaySteps]?.map((item, index) => {
        if (item !== '-NA-') {
          const parsed_Items = [];
          for (let i = 0; i < item?.length; i++) {
            parsed_Items.push(parseHTML((item[i] !== '-NA-' && item[i]) || ''));
          }
          return {
            title: {
              children: item.length > 0 && choice_Olay_StepsHead[index],
              primitive: 'h3',
            },
            list: parsed_Items?.map((parsedItem) => ({ children: parsedItem })),
          };
        }
        return null;
      });
      const choice_Olay_FtrArray = [...choice_OlayFtr]?.map((item, index) => ({
        children: choice_OlayFtr[index] !== '-NA-' && convertStringToElements(choice_OlayFtr[index]),
      }));
      const choice_Olay_DescArray = choice_OlayDesc?.map((item, index) => ({
        children: choice_OlayDesc[index] !== '-NA-' && choice_OlayDesc[index],
      }));
      const choice_Olay_ImgArray = choice_OlayImg?.map((item, index) => ({
        src: choice_OlayImg[index] !== '-NA-' && choice_OlayImg[index],
        alt: choice_OlayImg[index] && choice_OlayImg[index] !== '-NA-' && 'common product image',
      }));

      const planExtrasArgs = choice_Olay_Ttl?.map((item, index) => ({
        title: choice_Olay_TtlArray[index],
        subtitle: choice_Olay_DescArray[index],
        productImage: choice_Olay_ImgArray[index],
        intro: choice_Olay_SubheadArray[index],
        features: choice_Olay_FeatArray[index],
        redemptionSteps: choice_Olay_StepsArray[index],
        disclosures: choice_Olay_FtrArray[index],
        buttonData: {
          primary: {
            children: 'Close',
            onClick: () => {
              setExtras(null);
              closeExtrasModal();
              setExtras(false);
            },
          },
        },
      }));
      const extrasOverlaydata = planExtrasArgs;
      const promoListCommon =
        Array.isArray(extras_Title) &&
        extras_Title?.map(
          (item, index) =>
            extras_Title?.[index] !== '-NA-' && {
              title: {
                children: extras_Title?.[index],
              },
              subtitle: {
                children: (
                  <>
                    {promoDesc_Common[index]}{' '}
                    <PlanExtras
                      // eslint-disable-next-line eqeqeq
                      opened={showExtrasModal == `${extras_Title?.[index]}${index}`}
                      onOpenedChange={(e) => !e && setExtras(null)}
                      id="planExtrasModal"
                      data-track={JSON.stringify({
                        type: 'link',
                        name: `Close`,
                        data: { page: { detail: `${extras_Title?.[index]} modal` } },
                      })}
                      toggleButton={
                        <TextLink
                          role="button"
                          ariaLabel={`${extras_Title?.[index]} ${plan_ExtrasLink}`}
                          surface="dark"
                          type="inline"
                          data-track={JSON.stringify({
                            type: 'link',
                            name: `${plan_ExtrasLink !== '-NA-' && plan_ExtrasLink} | ${extras_Title?.[index]}`,
                            data: { page: { detail: `${extras_Title?.[index]} modal` } },
                          })}
                          onClick={() => {
                            setExtras(`${extras_Title?.[index]}${index}`);
                          }}
                        >
                          {plan_ExtrasLink !== '-NA-' && plan_ExtrasLink}
                        </TextLink>
                      }
                      {...(planExtrasArgs && planExtrasArgs?.[index])}
                    />
                  </>
                ),
              },
            },
        );
      const promoList = promo_Choice_Title?.map(
        (item, index) =>
          promo_Choice_Title?.[index] !== '-NA-' && {
            title: {
              children: promo_Choice_Title?.[index],
            },
            subtitle: {
              children: (
                <>
                  {promo_Desc[index + (extras_Title.length > 0 ? 1 : 0)]}{' '}
                  <PlanExtras
                    // eslint-disable-next-line eqeqeq
                    opened={showExtrasModal == `${promo_Choice_Title?.[index]}${index}`}
                    data-track={JSON.stringify({
                      type: 'link',
                      name: 'Close',
                      data: { page: { detail: `${promo_Choice_Title?.[index]} modal` } },
                    })}
                    onOpenedChange={(e) => !e && setExtras(null)}
                    id="planExtrasModal"
                    toggleButton={
                      <TextLink
                        role="button"
                        surface={getColorTheme() !== '' ? '' : 'dark'}
                        ariaLabel={`${promo_Choice_Title?.[index]} ${promo_DataVal?.[`planChoiceExtrasLink_${userType}`]?.[index]}`}
                        type="inline"
                        data-track={JSON.stringify({
                          type: 'link',
                          name: `${
                            promo_DataVal?.[`planChoiceExtrasLink_${userType}`]?.[index] !== '-NA-' &&
                            promo_DataVal?.[`planChoiceExtrasLink_${userType}`]?.[index]
                          } | ${promo_Choice_Title?.[index]}`,
                          data: { page: { detail: `${promo_Choice_Title?.[index]} modal` } },
                        })}
                        onClick={() => setExtras(`${promo_Choice_Title?.[index]}${index}`)}
                      >
                        {promo_DataVal?.[`planChoiceExtrasLink_${userType}`]?.[index] !== '-NA-' &&
                          promo_DataVal?.[`planChoiceExtrasLink_${userType}`]?.[index]}
                      </TextLink>
                    }
                    {...(extrasOverlaydata && extrasOverlaydata?.[index + (extras_Title.length > 0 ? extras_Title.length : 0)])}
                  />
                </>
              ),
            },
          },
      );
      const getExtras = {
        'data-track': JSON.stringify({
          name: promo_DataVal?.[`extrasCommonDesc_${userType}`] !== '-NA-' && promo_DataVal?.[`extrasCommonDesc_${userType}`],
          data: { page: { detail: 'plans accordion' } },
        }),
        header: {
          ...(extra_Callout && {
            badge: {
              children: extra_Callout,
              fillColor: getColorTheme() ? '' : featureData.order === 2 || featureData.order === '2' ? 'white' : 'red',
            },
          }),
          ...(primary_Image &&
            primary_Image !== '-NA-' && {
              image: {
                src: primary_Image !== '-NA-' && primary_Image,
              },
            }),
          title: {
            children: promo_DataVal?.[`extrasCommonDesc_${userType}`] !== '-NA-' && promo_DataVal?.[`extrasCommonDesc_${userType}`],
          },
        },
        content: [
          {
            items: promoListCommon,
          },
          {
            title: {
              children: promo_DataVal?.[`extraChoiceHeader_${userType}`] !== '-NA-' && promo_DataVal?.[`extraChoiceHeader_${userType}`],
            },
            helperText: {
              children: promo_DataVal?.[`extrasChoiceFooter_${userType}`] !== '-NA-' && promo_DataVal?.[`extrasChoiceFooter_${userType}`],
            },
            items: promoList,
          },
        ],
      };
      const strikedPriceObj = {};
      const strikedPriceVal = item?.price?.regPriceWOAutoPay;
      const finalPrice = item?.price?.discountedPrice;
      const widthVal = '130px';     
      if ((isLoggedIn() || isSequentialFlow() || isJointTransactionFlow()) && strikedPriceVal !== undefined && strikedPriceVal !== finalPrice) {
        strikedPriceObj.oldPrice = {
          leadingText: {
            children: 'was',
          },
          price: strikedPriceVal,
          term: 'month',
        };
      }
      tiles.push({
        kind: 'plan-home',
        title: { children: item?.displayName, size: 'large', viewport: 'mobile', width: widthVal },
        newPrice: {
          price: isMoversFlow ? item?.price?.discPriceWOAutoPay : autoPayOn ? item?.price?.discountedPrice : item?.price?.discPriceWOAutoPay,
          term: 'month',
          superscript: '*',
        },
        ...strikedPriceObj,
        discountPrice: !isEmp &&
          getTooltipContents(storeDetails, featureData, item) && {
            color: getColorTheme() ? 'secondary' : '',
            leadingText: {
              children: 'As low as',
            },
            price: featureData?.discountedPrice || '0',
            term: 'month',
            tooltip: {
              children: parseHTML(getTooltipContents(storeDetails, featureData, item) || ''),
              ariaLabel: `As low as ${featureData?.discountedPrice || '0'}/mo more information tooltip`,
            },
          },
        banner: {
          children: bestValueBannerText,
          fillColor: featureData.order === 2 || featureData.order === '2' ? (getColorTheme() ? 'stone' : 'gray') : 'red',
          surface: 'dark',
        },
        details: {
          leftTextLink: {
            children: 'Review details',
            ariaLabel: `Review details of ${item?.displayName}`,
            href: undefined,
            target: undefined,
            'data-track': JSON.stringify({ name: `Review details | ${item?.displayName} plan`, data: { page: { detail: 'plans accordion' } } }),
            onClick: () => {
              setShowModal(true);
              setShowModalData(reviewDetailsArgs);
            },
          },
          items: planProducts && getList(planProducts),
        },
        ...(Object.keys(promo_DataVal)?.length > 0 && promosLength && checkMoversFlag && { extras: getExtras }), // // ACT200-1371 Get Extras Section for progressive Tile dropdown
        footer: {
          buttonGroup: {
            data: [
              {
                id: 'selectButton',
                use: 'primary',
                ariaLabel: selectedPlan && selectedPlan?.planId === item.planId ? `${item?.displayName} Selected` : ` ${item?.displayName} Select `,
                children: selectedPlan && selectedPlan?.planId === item.planId ? 'Selected' : 'Select',
                disabled: selectedPlan && selectedPlan?.planId === item.planId,
                'data-track': JSON.stringify({
                  type: 'link',
                  name: `select| ${item?.displayName} plan`,
                  data: { page: { detail: 'plans accordion' } },
                }),
                onClick: (e) => planSelection(e, item),
              },
              {
                use: 'textLink',
                children: String(currentPlanObject?.planId) !== String(item?.planId) && checkIsMoversPlansPage() === true && (
                  <Margin margin={[10, 0]} className="textDecUnderline">
                    {props?.comparePlanLinkTxt}
                  </Margin>
                ),
                ariaLabel: `Compare plan`,
                id: 'compare-plan-CTA',
                'data-testid': 'compare-plan-CTA',
                onClick: () => {
                  toggleOnComplarePlanModel();
                  updateSelectedPlanDetails(item);
                },
              },
            ],
          },
        },
      });
    });
    return tiles;
  };
  const onAutoPayChange = (e, on) => {
    if (on) {
      dispatch({ type: actionTypes.UPDATE_AUTO_PAY, payload: true });
    } else if (!on) {
      dispatch({ type: actionTypes.UPDATE_AUTO_PAY, payload: false });
    }
  };
  const getAutoPay = () => ({
    toggle: {
      helperText: {
        children: 'Show pricing with Auto Pay & paper-free billing discount. Set up after purchase.',
        tooltip: {
          ariaLabel: `Show pricing with Auto Pay & paper-free billing discount. Set up after purchase more info`,
          title: '',
          children:
            'When you enroll in Auto Pay and paper free billing using your bank account or Verizon Visa Card, you qualify for a $10/mo discount. Your discount will be applied beginning with your next bill cycle after enrollment in Auto Pay and paper-free billing.',
          'data-track': 'autopay toggle tooltip',
        },
      },
      toggle: {
        ariaLabel: 'Show pricing with Auto Pay and Paper-free billing discount. Set up after purchase',
        'data-track': `autopay toggled ${autoPayOn ? 'false' : 'true'}`,
        on: autoPayOn,
        onChange: (e, element) => onAutoPayChange(e, element.on),
      },
    },
  });

  const getFootNote = () => {
    const footNote = {
      children: (
        <>
          {checkMoversFlag ? (
            <span style={{ color: 'grey' }}>* Plan prices include taxes and fees</span>
          ) : (
            <span>
              * Plan prices include taxes, fees and eligible discounts. Changes to your plans or account could result in a change in your discount.
            </span>
          )}
          <br />
          <br />
          Jump to{' '}
          <TextLink
            id="scrollToBroadBandFacts"
            onClick={() => scrollToBroadBandFacts()}
            data-track='{"type": "link","name": "broadband facts labels","data":{"page":{"detail":"progressive plan" }}}'
          >
            broadband facts labels
          </TextLink>{' '}
          for pricing and technical information.
          <br />
          <br />
          Please review our <IPILink /> and{' '}
          <TextLink
            onClick={() => broadBandInfoClick()}
            data-track='{"type": "link","name": "important broadband information","data":{"page":{"detail":"progressive plan" }}}'
          >
            important broadband information
          </TextLink>
          .
        </>
      ),
    };
    return footNote;
  };
  const updatedProps = { ...props, plansAccordianContainerId, toggleDisneyPerkDetailModel: setShowDisneyPerkDetailModel };
  const finalArgs = ProgressivePlansProps(updatedProps);
  const allPlanDetails = storeDetails?.cBandPlans?.plansDetails || {};
  const lineLevel = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.lineLevelPlans
    ? storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.lineLevelPlans
    : {};
  const overviewData = allPlanDetails?.willowOverview?.[0] || {};
  let plans = [];
  if (lineLevel?.lines?.length > 0 && lineLevel?.lines[0].products?.length > 0 && lineLevel?.lines[0].products[0].plans?.length > 0) {
    plans = lineLevel?.lines[0].products[0].plans?.sort(
      (plan1, plan2) => parseInt(plan1?.price?.regularPrice) - parseInt(plan2?.price?.regularPrice),
    );
    if (isMoversFlow && plans && plans?.length > 0) {
      plans = plans.filter((item) => String(item?.planId) !== String(currentPlanObject?.planId));
    }
  }
  const planref = getProductsRefDataId(plans);
  const sortedPlanIds = Object.keys(planref || {})
    .filter((planId) => planref[planId])
    .sort((planId, nextPlanId) => plans?.[planId]?.order - plans?.[nextPlanId]?.order);
  const jointMHDiscountSubTitle = "You'll save on your Home Internet plan because you're also purchasing a postpaid mobile unlimited plan today.";
  let availablePromotions = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.availablePromotions || [];
  if (isEmp) {
    availablePromotions = ['Employee'];
  }
  const employeeDiscount = planref?.[sortedPlanIds[0]]?.price?.promos
    ?.find((promo) => promo?.promoDescription?.includes('ACCESS DISCOUNT'))
    ?.percentageOff?.split('.')[0];
  const autopayDiscount = planref?.[sortedPlanIds[0]]?.price?.promos?.find((promo) => promo?.promoDescription?.includes('AUTOPAY'))?.amountOff;
  const dawCoupon = getSession('couponToken');
  const items = sortedPlanIds?.map((planId) => {
    const discountPromo = planref?.[planId]?.price?.promos?.find((promo) => promo?.promoDescription?.includes('MOBILE + HOME DISCOUNT'));
    const planName = willowFeatures?.[planId]?.planName;
    return {
      title: {
        children: planName,
      },
      amount: {
        price: `-$${discountPromo?.amountOff}`,
        id: `Mobile + Home Discount ${planName} -$${discountPromo?.amountOff}`,
      },
    };
  });
  items.push({
    title: {
      children: isJointTransactionFlow() ? jointMHDiscountSubTitle : overviewData?.MHDiscountSubTitle,
    },
  });

  const { planReferenceDataList } = storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data
    ? storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data
    : {};
  const planAccordionState = storeDetails?.progressivePlans?.planAccordionState || {};
  const tileCreated = plans && getTiles(plans, planReferenceDataList, allPlanDetails);
  const throttleValues = storeDetails?.SessionValues?.fwaCradleValues;
  finalArgs.accordion.plans.tiles = tileCreated;
  finalArgs.accordion.plans.autoPay = !isEmp ? checkMoversFlag && getAutoPay() : '';
  finalArgs.accordion.plans.footnote = getFootNote();
  const arrgs = {
    theme: getColorTheme(),
    planTileGroupMaxWidth: '814px',
    wayfinder: showLQAddress && getWayfinder(props, throttleValues, setShowLQAddress),
    title: finalArgs.title,
    accordion: finalArgs.accordion,
    pricingDetails: finalArgs.pricingDetailsProps,
    notification: finalArgs.notification,
    action: finalArgs.getActionProps,
    footer: isJointTransactionFlow() ? '' : finalArgs.footerProps,
    ...((isLoggedIn() || isSequentialFlow() || isJointTransactionFlow()) &&
      availablePromotions.length && {
        subtitle: {
          children: 'You have plan discounts.',
        },
        helperText: {
          children: (
            <PlanDiscountModal
              id="discountsModal"
              toggleButton={getDiscountLabel(availablePromotions)}
              {...discountArgs(
                overviewData,
                availablePromotions,
                items,
                isEmp,
                employeeDiscount,
                autopayDiscount,
                closeExtrasModal,
                showDiscountsModal,
                setShowDiscountsModal,
              )}
            />
          ),
        },
      }),
  };
  const notificationProps = {
    renderIf: true,
    title: props?.notificationVfTitle,
    subtitle: '',
    type: 'success',
    hideCloseButton: false,
    serviceInfo: '',
    buttonData: [
      {
        children: 'Learn more',
        onClick: () => {
          setVfShowModal(true);
          // this.VFModalTagging();
        },
        'data-track': `{"type": "link",  "name": " learn more - vfwd"}`,
      },
    ],
  };
  const promo_BannerText = allPlanDetails?.willowOverview?.[0]?.promoBannerText;
  const promoBannerMoreInfo = allPlanDetails?.willowOverview?.[0]?.promoBannerMoreInfo || '';
  const notificationPropsForDaw = {
    renderIf: true,
    title: props?.notificationDawTitle,
    subtitle: '',
    type: 'info',
    hideCloseButton: false,
    serviceInfo: '',
  };
  const notificationBannerProps = {
    renderIf: false,
    title: '',
    type: 'warning',
    serviceInfo: '',
  };
  const showError = storeDetails?.cBandPlans?.showError;
  if (showError) {
    notificationBannerProps.renderIf = true;
    notificationBannerProps.title = commonErrors && commonErrors?.defaultMessage;
    notificationBannerProps.serviceInfo = storeDetails?.cBandPlans?.planServiceinfo;
  }

  return (
    <>
      {checkMoversFlag && promo_BannerText && (
        <BannerDiv>
          <Body size="large" color="#FFFFFF">
            <span className={`${!isMobile() ? 'dispFlex' : ''} flexWrap justifyContentCenter alignItemsCenter fontsize_18`}>
              {parse(promo_BannerText)}
            </span>
          </Body>
        </BannerDiv>
      )}
      <Notification {...notificationBannerProps} />
      {isVFEligibile() && props.notificationVfTitle && <Notification {...notificationProps} />}
      {dawCoupon && props?.notificationDawTitle && <Notification {...notificationPropsForDaw} />}
      {isResponsiveLQ && !showLQAddress && <div id="lq-widget-root" />}
      <>
        <FWAContainer hideLinks topBufferAuto enableLiveSupport title={props.title} className="progressive-full-width">
          <Row className="progressive-full-width">
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }} className="progressive-full-width">
              <ProgressiveDisclosure {...arrgs} toggleDisneyPerkDetailModel={setShowDisneyPerkDetailModel} key={planAccordionState?.lastUpdated} />
            </Col>
          </Row>
        </FWAContainer>
      </>

      {showModal && <ReviewDetailsModal {...showModalData} opened={showModal} onOpenedChange={modalChanged} />}
      {perkPdpOverlay?.show && (
        <PerkDetailOverlay
          toggleDisneyPerkDetailModel={setShowDisneyPerkDetailModel}
          specialOfferTitle={specialOfferTitle}
          disneyPromoBannerTitle={disneyPromoBannerTitle}
          disneyPerkDetailsModelBody={disneyPerkDetailsModelBody}
        />
      )}
      {termsAndConditionsOverlay?.show && <TermsAndConditionsOverlay />}

      {showVfModal && props?.vfModalTitle && (
        <Modal
          id="acpInfoModal"
          opened={showVfModal}
          onOpenedChange={vfModalChanged}
          disableOutsideClick
          analyticstrack="verizon forward overlay - open"
          ariaLabel="verizon forward overlay"
        >
          <ModalTitle>
            {parseHTML(props?.vfModalTitle)}
          </ModalTitle>

          <ModalBody>
            <Margin top="10px">
              <ACPModalBody>{parseHTML(props?.vfModalBody)}</ACPModalBody>
            </Margin>
          </ModalBody>
          <ModalFooter
            buttonData={{
              primary: {
                width: isMobile() ? '100%' : '200px',
                children: 'Got it',
                onClick: () => setVfShowModal(false),
              },
            }}
          />
        </Modal>
      )}

      {showComparePlanModel && (
        <ComparePlanComponent
          toggleOnComplarePlanModel={toggleOnComplarePlanModel}
          toggleOffComplarePlanModel={toggleOffComplarePlanModel}
          showComparePlanModel={showComparePlanModel}
          comparePlanDetails={comparePlanDetails}
          newPlanId={currentSelectedPlanDetails?.planId}
          newPlanObject={{
            planDisplayName: currentSelectedPlanDetails?.displayName,
            finalPrice: currentSelectedPlanDetails?.price?.discPriceWOAutoPay,
            planId: currentSelectedPlanDetails?.planId,
          }}
          currentPlanId={currentPlanObject?.planId}
          currentPlanObject={{
            planDisplayName: currentPlanObject?.obj?.displayName,
            finalPrice: currentPlanObject?.obj?.price?.availablePlanDiscountedPrice,
            planId: currentPlanObject?.obj?.planId,
          }}
          onPlanSelect={(e) => planSelection(e, currentSelectedPlanDetails)}
          priceGuarteeDetails={{
            newPlanDetails: getComparePlansPrice('', [currentSelectedPlanDetails?.planId], storeDetails?.plansReferenceData?.output, isLegacyPlan),
            currentPlanDetails:
              isLegacyPlan === false
                ? getComparePlansPrice('', [currentPlanObject?.planId], storeDetails?.plansReferenceData?.output, isLegacyPlan)
                : getPriceGuarantee(cbandFedDetails?.plans?.[currentPlanObject?.planId]?.highlights, isLegacyPlan),
          }}
        />
      )}

      <Modal
        id="disneyPerkPromoModal"
        opened={showDisneyPerkDetailModel}
        onOpenedChange={(state) => setShowDisneyPerkDetailModel(state)}
        disableOutsideClick
        ariaLabel="disney perk detail modal"
      >
        <ModalTitle>{parse(disneyPerkDetailsModelHeader || '')}</ModalTitle>
        <ModalBody>
          <div>{parse(disneyPerkDetailsModelBody?.[0] || '')}</div>
          <Margin top="16px">
            <p className="fontSize_11 lineHeight16">{parse(disneyPerkDetailsModelBody?.[1] || '')}</p>
          </Margin>
        </ModalBody>
        <ModalFooter>
          <Button width={isMobile() ? '100%' : ''} onClick={() => setShowDisneyPerkDetailModel(false)}>
            Got it
          </Button>
        </ModalFooter>
      </Modal>

      {promoBannerMoreInfo && (
        <Modal
          id="offerDetailModal"
          opened={showPromoModal}
          onOpenedChange={toggleOfferModalVal}
          disableOutsideClick
          ariaLabel={parse(promoBannerMoreInfo)}
        >
          <ModalBody>{parse(promoBannerMoreInfo)}</ModalBody>
        </Modal>
      )}
      <PerkDisclosureModal />
      <PerkDuplicateModal pageName="progressivePlan" history={props?.history} />
      <PerkConflictModal />
    </>
  );
};

ProgressivePlans.propTypes = {
  invokeTaggingAPI: PropTypes.func,
  notificationVfTitle: PropTypes.string,
  notificationDawTitle: PropTypes.string,
  vfModalTitle: PropTypes.string,
  vfModalBody: PropTypes.string,
  title: PropTypes.string,
  readDlPlans: PropTypes.bool,
  history: PropTypes.object,
  getAddons: PropTypes.func,
  bestValueTxt: PropTypes.string,
  comparePlanLinkTxt: PropTypes.string,
};

export default ProgressivePlans;
